import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Link,
  VStack,
  HStack,
  Icon,
  Image,
  Separator,
} from '@chakra-ui/react';
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const Footer = () => {
  const FooterLink = ({ children, href = "#" }) => (
    <Link
      href={href}
      color="gray.600"
      fontSize="sm"
      _hover={{ color: 'purple.600', textDecoration: 'none' }}
      transition="color 0.2s"
    >
      {children}
    </Link>
  );

  return (
    <Box bg="gray.50" color="gray.700">
      <Container maxW="7xl" py={{ base: 12, md: 16 }}>
        <SimpleGrid 
          columns={{ base: 1, md: 3 }} 
          gap={{ base: 8, md: 12 }}
          mb={8}
        >
          {/* Company Info */}
          <VStack align={{ base: "center", md: "start" }} gap={4}>
            <Image 
              src="/logo y texto cadencya.png" 
              alt="Cadencya" 
              h={{ base: "55px", md: "70px" }}
              w="auto"
            />
            <Text 
              color="gray.600"
              fontSize="sm"
              textAlign={{ base: "center", md: "left" }}
              maxW="250px"
            >
              Toda tu música, en un solo lugar. Gestión de bandas, archivo y web pública.
            </Text>
            <HStack gap={4} pt={2}>
              <Link
                href="https://www.facebook.com/profile.php?id=61579336839907"
                _hover={{ color: 'purple.600' }}
                target='_blank'
                rel='noopener noreferrer'>
                <Icon w={5} h={5} asChild><FaFacebook /></Icon>
              </Link>
              <Link
                href="https://x.com/cadencya_app"
                _hover={{ color: 'purple.600' }}
                target='_blank'
                rel='noopener noreferrer'>
                <Icon w={5} h={5} asChild><FaXTwitter /></Icon>
              </Link>
              <Link
                href="https://www.instagram.com/cadencya_app/"
                _hover={{ color: 'purple.600' }}
                target='_blank'
                rel='noopener noreferrer'>
                <Icon w={5} h={5} asChild><FaInstagram /></Icon>
              </Link>
              <Link
                href="https://www.tiktok.com/@cadencya_app"
                _hover={{ color: 'purple.600' }}
                target='_blank'
                rel='noopener noreferrer'>
                <Icon w={5} h={5} asChild><FaTiktok /></Icon>
              </Link>
            </HStack>
          </VStack>

          {/* Links */}
          <VStack align={{ base: "center", md: "start" }} gap={3}>
            <Text fontWeight="700" color="gray.800" fontSize="sm">
              Empresa
            </Text>
            <VStack align={{ base: "center", md: "start" }} gap={2}>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/bandas#producto">Producto
                              </RouterLink></Link>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/planes">Planes
                              </RouterLink></Link>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/sobre-nosotros">Sobre nosotros
                              </RouterLink></Link>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/como-funciona">Cómo funciona
                              </RouterLink></Link>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/hermandades">Para hermandades
                              </RouterLink></Link>
              <Link
                href="/manual-usuario-cadencya.pdf?v=20260927"
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                download
              >
                Manual de usuario
              </Link>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/contacto">Contacto
                              </RouterLink></Link>
              <Link
                href="https://blog.cadencya.com"
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                target='_blank'
                rel='noopener noreferrer'>
                Blog
              </Link>
            </VStack>
          </VStack>

          {/* Legal */}
          <VStack align={{ base: "center", md: "start" }} gap={3}>
            <Text fontWeight="700" color="gray.800" fontSize="sm">
              Legal
            </Text>
            <VStack align={{ base: "center", md: "start" }} gap={2}>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/terminos-de-uso">Términos de uso
                              </RouterLink></Link>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/politica-privacidad">Política de privacidad
                              </RouterLink></Link>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/politica-cookies">Cookies
                              </RouterLink></Link>
              <Link
                color="gray.600"
                fontSize="sm"
                _hover={{ color: 'purple.600', textDecoration: 'none' }}
                transition="color 0.2s"
                asChild><RouterLink to="/ayuda">Ayuda
                              </RouterLink></Link>
            </VStack>
          </VStack>
        </SimpleGrid>

        <Separator borderColor="gray.300" />

        {/* Bottom */}
        <Stack
          direction={{ base: 'column', md: 'row' }}
          gap={4}
          justify="space-between"
          align="center"
          pt={8}
        >
          <Text fontSize="sm" color="gray.600" textAlign={{ base: "center", md: "left" }}>
            © {new Date().getFullYear()} Cadencya. Todos los derechos reservados.
          </Text>
          <Text fontSize="xs" color="gray.500" textAlign={{ base: "center", md: "right" }}>
            Hecho con ❤️ para la comunidad cofrade
          </Text>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
